import Button from "@mui/material/Button";
import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const BaseButton = ({
  children,
  type,
  path = "",
  className,
  variant = "contained",
  disableElevation = true,
  color = "secondary",
  hoverLight = false,
  onClick,
  style,
  icon,
  outlinedHover,
  textSize,
  loaderSize,
  loaderColor = "secondary",
  disabled,

  isLoading = false,
  ...props
}) => {
  return (
    <Button
      sx={{
        "&.Mui-disabled": {
          opacity: disabled && 0.5,
          /*  backgroundColor: disabled && "#F6F6F6 !important",
          color: disabled && "#c4c4c4 !important", */
        },
      }}
      style={style}
      onClick={onClick}
      color={color}
      disableElevation={disableElevation}
      type={type}
      {...props}
      className={`cursor-pointer ${className} ${
        textSize ? textSize : `text-[13px]`
      } font-light hover:shadow-lg ease-in duration-900  py-3 px-[18px] ${
        outlinedHover &&
        "border-white hover:bg-slate-50/20 shadow-md hover:shadow-white/50"
      } ${
        hoverLight == true ? "hover:shadow-white/50" : "hover:shadow-black/20"
      }
        
        ${variant === "outlined" ? "hover:text-white hover:bg-" + color : ""}
        
        `}
      variant={variant}
      disabled={disabled ? disabled : isLoading ? true : false}
      endIcon={
        isLoading && <CircularProgress color={color} size={loaderSize} />
      }
    >
      {!isLoading && children}

      {icon && !isLoading && <span className="">{icon}</span>}
    </Button>
  );
};

export default BaseButton;
